import React, { useState, useEffect, useCallback, ChangeEvent } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import api from '../../../../services/api';
import { useToast } from '../../../../hooks/toast';
import { useAuth } from '../../../../hooks/auth';

import BackHeader from '../../../../components/BackHeader';
import {
  H2,
  Label,
  NotFoundContainer,
  Skeleton,
} from '../../../../components/Generic';
import { Container, Content, TransferenceItem } from './styles';
import Button from '../../../../components/Button';
import { IconCirclePlus, IconInfoCircle } from '@tabler/icons';
import moment from 'moment';
import Modal from '../../../../components/Modal';
import PropertyItem from '../../../../components/PropertyItem';

const Transferences: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [transferences, setTransferences] = useState<any>([]);

  const [selectedTransference, setSelecetedTransference] = useState('');
  const [properties, setProperties] = useState<any[]>([]);

  const { id }: any = useParams();
  const { addToast } = useToast();
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await api.get('/transferences', {
        headers: {
          target_user_id: user.id,
          propriedade_id: id,
        },
      });

      console.log(response.data);
      setTransferences(response.data);

      const propertiesResponse = await api.get('/propriedades/minhas');
      setProperties(propertiesResponse.data.minhasPropriedades);
    } catch (err) {
      console.log(err);

      addToast({
        type: 'error',
        title: 'Erro!',
        description: 'Não foi possível carregar as transferências',
      });
    } finally {
      setLoading(false);
    }
  };

  const acceptTransference = async (
    transferenceId: string,
    propertyId: string,
  ) => {
    try {
      await api.put(
        `/transferences/target_property/${transferenceId}`,
        {
          target_property_id: propertyId,
        },
        {
          headers: {
            propriedade_id: propertyId,
          },
        },
      );

      await api.put(
        `/transferences/confirm/${transferenceId}`,
        {
          receiver_confirmation: true,
        },
        {
          headers: {
            propriedade_id: propertyId,
          },
        },
      );
      addToast({
        type: 'success',
        title: 'Feito!',
        description: 'Animais recebidos.',
      });

      setSelecetedTransference('');

      history.replace(`/propriedade/${propertyId}`);
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro!',
        description: err.response.data.message || 'Algo deu errado!',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <BackHeader title="Notificações" />

      {loading ? (
        <Content>
          <Skeleton style={{ height: 60, width: '100%', marginBottom: 30 }} />
          <Skeleton style={{ height: 40, width: '100%', marginBottom: 10 }} />
          <Skeleton style={{ height: 40, width: '100%', marginBottom: 10 }} />
        </Content>
      ) : (
        <Content>
          <Label>Transferências</Label>

          {transferences?.map((transference: any) => (
            <TransferenceItem key={transference.id}>
              <div className="user">
                <img src={transference.users?.url} alt="Foto" />
                <span>{transference.users?.nome}</span>

                <span>enviou animais</span>
              </div>

              <span>
                {moment(transference.created_at).format('DD/MM/YYYY HH:mm')}
              </span>

              <button onClick={() => setSelecetedTransference(transference.id)}>
                Aceitar
              </button>
            </TransferenceItem>
          ))}

          {transferences.length === 0 && (
            <NotFoundContainer>
              <IconInfoCircle size={24} />

              <strong>Sem transferências.</strong>
            </NotFoundContainer>
          )}
        </Content>
      )}

      <Modal
        isOpen={!!selectedTransference}
        onClose={() => setSelecetedTransference('')}
      >
        <H2>Escolha uma propriedade de destino</H2>

        {properties?.length > 0 ? (
          properties?.map(property => (
            <PropertyItem
              key={property.id}
              location={property.descricao}
              name={property.nome}
              imageUrl={
                property.imagens?.length > 0
                  ? property.imagens[0]?.image_url
                  : ''
              }
              onClick={() =>
                acceptTransference(selectedTransference, property.id)
              }
            />
          ))
        ) : (
          <NotFoundContainer>
            <IconInfoCircle size={24} />

            <strong>Nenhuma propriedade encontrada.</strong>
          </NotFoundContainer>
        )}
      </Modal>
    </Container>
  );
};

export default Transferences;
